<template>
  <div class="wrapper">
    <div class="content-wrapper">
      <section class="content p-3">
        <div class="container-fluid">
          <!-- Card de Bienvenida -->
          <div class="col-md-12 mb-4">
            <div class="card">
              <div class="card-body text-center">
                <img src="img/Logo-STS.png" alt="AdminLTE Logo" class="brand-image img-circle elevation-2"
                  style="opacity: 0.9" />
                <h3>Bienvenido</h3>
                <h5>
                  {{ $store.getters.getUser.name }}
                </h5>
              </div>
            </div>
          </div>

          <!-- Cards de Acceso Rápido -->
          <div class="row">
            <div class="col-12 mb-3">
              <h4 class="mb-3">
                <i class="fas fa-bolt mr-2 text-warning"></i>
                Acceso Rápido
              </h4>
            </div>

            <!-- Card: Conteo manual de buses (ConteoRutas) -->
            <div class="col-md-6 col-lg-4 col-xl-3 mb-4" v-if="$store.getters.can('operacion.conteoRodamientos.index')">
              <router-link to="/Operacion/ConteoRutas" class="home-quick-access-card">
                <div class="card card-outline card-danger h-100 shadow-sm">
                  <div class="card-body text-center p-4">
                    <div class="home-card-icon bg-danger">
                      <i class="fas fa-hand-pointer fa-2x text-white"></i>
                    </div>
                    <h5 class="mt-3 mb-2 font-weight-bold">Conteo de buses</h5>
                    <p class="text-muted small mb-0">Press largo para conteo seguro por empresa</p>
                  </div>
                  <div class="card-footer bg-danger text-white text-center py-2">
                    <small>
                      <i class="fas fa-arrow-right mr-1"></i>
                      Acceder
                    </small>
                  </div>
                </div>
              </router-link>
            </div>

            <!-- Card 1: Control de Tiempo -->
            <div class="col-md-6 col-lg-4 col-xl-3 mb-4"
              v-if="$store.getters.can('operacion.controlTiempoForm.create')">
              <router-link to="/Operacion/controlTiempoForm" class="home-quick-access-card">
                <div class="card card-outline card-primary h-100 shadow-sm">
                  <div class="card-body text-center p-4">
                    <div class="home-card-icon bg-primary">
                      <i class="fas fa-clock fa-2x text-white"></i>
                    </div>
                    <h5 class="mt-3 mb-2 font-weight-bold">Control de Tiempo</h5>
                    <p class="text-muted small mb-0">Registro de control de tiempo</p>
                  </div>
                  <div class="card-footer bg-primary text-white text-center py-2">
                    <small>
                      <i class="fas fa-arrow-right mr-1"></i>
                      Acceder
                    </small>
                  </div>
                </div>
              </router-link>
            </div>

            <!-- Card: Despachos -->
            <div class="col-md-6 col-lg-4 col-xl-3 mb-4" v-if="$store.getters.can('operacion.despachos.index')">
              <router-link to="/Operacion/Despachos" class="home-quick-access-card">
                <div class="card card-outline card-orange h-100 shadow-sm">
                  <div class="card-body text-center p-4">
                    <div class="home-card-icon bg-orange">
                      <i class="fas fa-clipboard-list fa-2x text-white"></i>
                    </div>
                    <h5 class="mt-3 mb-2 font-weight-bold">Despachos</h5>
                    <p class="text-muted small mb-0">Registro de salida y llegada de despachos</p>
                  </div>
                  <div class="card-footer bg-orange text-white text-center py-2">
                    <small>
                      <i class="fas fa-arrow-right mr-1"></i>
                      Acceder
                    </small>
                  </div>
                </div>
              </router-link>
            </div>

            <div class="col-md-6 col-lg-4 col-xl-3 mb-4" v-if="$store.getters.can('recaudo.preliquidaciones.index')">
              <router-link to="/Recaudo/Preliquidaciones" class="home-quick-access-card">
                <div class="card card-outline card-info h-100 shadow-sm">
                  <div class="card-body text-center p-4">
                    <div class="home-card-icon bg-info">
                      <i class="fas fa-file-invoice-dollar fa-2x text-white"></i>
                    </div>
                    <h5 class="mt-3 mb-2 font-weight-bold">Preliquidaciones</h5>
                    <p class="text-muted small mb-0">Gestión de preliquidaciones</p>
                  </div>
                  <div class="card-footer bg-info text-white text-center py-2">
                    <small>
                      <i class="fas fa-arrow-right mr-1"></i>
                      Acceder
                    </small>
                  </div>
                </div>
              </router-link>
            </div>

            <!-- Card 4: Ejemplo - Agregar más cards aquí -->

            <div class="col-md-6 col-lg-4 col-xl-3 mb-4" v-if="$store.getters.can('recaudo.liquidaciones.index')">
              <router-link to="/Recaudo/Liquidaciones" class="home-quick-access-card">
                <div class="card card-outline card-warning h-100 shadow-sm">
                  <div class="card-body text-center p-4">
                    <div class="home-card-icon bg-warning">
                      <i class="fas fa-hand-holding-usd fa-2x text-white"></i>
                    </div>
                    <h5 class="mt-3 mb-2 font-weight-bold">Recaudo Liquidaciones</h5>
                    <p class="text-muted small mb-0">Gestión de recaudo de liquidaciones</p>
                  </div>
                  <div class="card-footer bg-warning text-white text-center py-2">
                    <small>
                      <i class="fas fa-arrow-right mr-1"></i>
                      Acceder
                    </small>
                  </div>
                </div>
              </router-link>
            </div>

            <div class="col-md-6 col-lg-4 col-xl-3 mb-4" v-if="$store.getters.can('recaudo.turnosEmision.index')">
              <router-link to="/Recaudo/TurnoEmision" class="home-quick-access-card">
                <div class="card card-outline card-success h-100 shadow-sm">
                  <div class="card-body text-center p-4">
                    <div class="home-card-icon bg-success">
                      <i class="far fa-credit-card fa-2x text-white"></i>
                    </div>
                    <h5 class="mt-3 mb-2 font-weight-bold">Turnos de Emisión</h5>
                    <p class="text-muted small mb-0">Gestión de turnos de emisión</p>
                  </div>
                  <div class="card-footer bg-success text-white text-center py-2">
                    <small>
                      <i class="fas fa-arrow-right mr-1"></i>
                      Acceder
                    </small>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeView",
};
</script>

<style scoped>
.home-quick-access-card {
  text-decoration: none;
  color: inherit;
  display: block;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.home-quick-access-card:hover {
  text-decoration: none;
  color: inherit;
  transform: translateY(-5px);
}

.home-quick-access-card:hover .card {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15) !important;
}

.home-quick-access-card .card {
  border-radius: 0.5rem;
  transition: all 0.3s ease;
  cursor: pointer;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.home-quick-access-card .card:hover {
  border-color: transparent;
}

.home-card-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
}

.home-quick-access-card:hover .home-card-icon {
  transform: scale(1.1);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
}

.home-quick-access-card .card-body {
  min-height: 180px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.home-quick-access-card .card-footer {
  border-radius: 0 0 0.5rem 0.5rem;
  transition: all 0.3s ease;
}

.home-quick-access-card:hover .card-footer {
  background: linear-gradient(to bottom, #05a85a, #8fc74b) !important;
}

/* Responsive */
@media (max-width: 768px) {
  .home-quick-access-card .card-body {
    min-height: 150px;
    padding: 1.5rem !important;
  }

  .home-card-icon {
    width: 60px;
    height: 60px;
  }

  .home-card-icon i {
    font-size: 1.5rem !important;
  }
}
</style>
